export { default } from "./ToggleContent.component";
